import React from 'react';
import Grid from '@material-ui/core/Grid';
import { StatsItem } from 'features/command-center';
import { useStyles } from 'features/command-center/components/shared';
import { COMMAND_CENTER_BASE_URL, ENDPOINTS } from 'features/command-center/constants';
import { useFetchWithStatusV2 } from 'hooks/fetchWithStatus';
import { SECONDARY_API_CLIENT } from 'services/API';
import strings from 'strings';
import { FPCard } from 'UI/components/atoms/FPCard';
import { UIStatus } from 'UI/constants/status';
import { currencyFormatter } from 'UI/utils';

export const FallOffsBoardWidgets = ({ queryParams }) => {
  const classes = useStyles();

  const { state } = useFetchWithStatusV2({
    endpoint: `${COMMAND_CENTER_BASE_URL}/${ENDPOINTS.fallOffsBoardHeaders}?${queryParams}`,
    apiInstance: SECONDARY_API_CLIENT
  });

  const loading = state.status === UIStatus.Loading;
  const { percentage, totalFalloff, totalFalloffProduction, totalProduction } = state.results ?? {};

  const items = [
    {
      loading,
      title: strings.commandCenter.fallOffsBoard.widgets.count,
      value: totalFalloff || 0
    },
    {
      loading,
      title: strings.commandCenter.fallOffsBoard.widgets.total,
      value: currencyFormatter(totalFalloffProduction || 0)
    },
    {
      loading,
      title: strings.commandCenter.fallOffsBoard.widgets.totalProduction,
      value: currencyFormatter(totalProduction || 0)
    },
    {
      loading,
      title: strings.commandCenter.fallOffsBoard.widgets.percentage,
      value: `${percentage || 0} %`
    }
  ];

  return items.map(item => (
    <Grid key={item.title} item xs={3}>
      <FPCard>
        <div className={classes.widgetContainer}>
          <StatsItem size="large" {...item} />
        </div>
      </FPCard>
    </Grid>
  ));
};
